import type { Perf } from "./api";

export const Dots = ({ v }: { v: number }) => (
  <span className="bl-dots">
    {[1, 2, 3, 4, 5].map((i) => <span key={i} className={`bl-dot ${i <= v ? "on" : ""}`} />)}
  </span>
);

export const PerfRow = ({ label, before, after }: { label: string; before: number; after: number }) => (
  <div className="flex items-center gap-2 text-sm" data-testid={`perf-${label}`}>
    <span className="bl-sub" style={{ width: 52 }}>{label}</span>
    <Dots v={before} />
    <span style={{ color: "var(--bl-gold)" }}>←</span>
    <Dots v={after} />
  </div>
);

export const GENDER_AR: Record<string, string> = { M: "رجالي", W: "نسائي", U: "للجنسين" };

export function perfDelta(b: Perf, a: Perf): boolean {
  return a.longevity > b.longevity || a.projection > b.projection || a.sillage > b.sillage;
}

/** "22–24%" | "18–20% EDP" → midpoint number (23 / 19). */
export function parseConcentration(c: string | null | undefined): number {
  if (!c) return 20;
  const nums = (c.match(/\d+/g) || []).map(Number);
  if (!nums.length) return 20;
  return nums.length >= 2 ? (nums[0] + nums[1]) / 2 : nums[0];
}
